import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '../button';

export default class SubmitButton extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    buttonOnly: PropTypes.bool, // deprecated
    pushRight: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { buttonOnly, pushRight, ...props } = this.props;

    const btn = <Button type="submit" primary {...props} />;

    return pushRight || !buttonOnly ? (
      <div style={{ textAlign: 'right' }}>{btn}</div>
    ) : (
      btn
    );
  }
}
